import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { ApiService } from 'app/lib/api.service';
import { LogService } from 'app/lib/log.service';
import { User } from 'app/models/user';
import { ProfessionalService } from '../professional.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActionPlanDashboard } from 'app/models/action-plan';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { UserDetailsOverviewComponent } from '../user-details-overview/user-details-overview.component';
import { AssessmentViewComponent } from '../assessment-view/assessment-view.component';
import { MoodcheckViewComponent } from '../moodcheck-view/moodcheck-view.component';
import { UserDetailsSeriesComponent } from '../user-details-series/user-details-series.component';
import { ActionPlanViewComponent } from '../action-plan-view/action-plan-view.component';
import { ToolsViewComponent } from '../tools-view/tools-view.component';
import { UserOrgOwnContentComponent } from '../user-org-own-content/user-org-own-content.component';

@Component({
    selector: 'app-user-details-dashboard',
    templateUrl: './user-details-dashboard.component.html',
    styleUrls: ['./user-details-dashboard.component.scss'],
    standalone: false
})
export class UserDetailsDashboardComponent implements OnInit {
    [x: string]: any;
    paramsSub: any;
    id: number;
    user: User;
    countData: any;
    demographicDetail: any;
    isLoaded: boolean = false;
    selectedTabIndex: number = 0;
    userDetailOverview: boolean = false;
    assessmentView: boolean = false;
    moodcheckView: boolean = false;
    actionplanView: boolean = false;
    seriesView: boolean = false;
    toolsView: boolean = false;
    orgContentView: boolean = false;
    date = new Date();
    userActionPlans = [];
    @ViewChild(UserDetailsOverviewComponent) userDetailsOverviewComp!: UserDetailsOverviewComponent;
    @ViewChild(AssessmentViewComponent) userDetailsAssessmentComp!: AssessmentViewComponent;
    @ViewChild(MoodcheckViewComponent) userDetailsMoodcheckComp!: MoodcheckViewComponent;
    @ViewChild(UserDetailsSeriesComponent) userDetailsSeriesComp!: UserDetailsSeriesComponent;
    @ViewChild(ActionPlanViewComponent) userDetailsActionPlanComp!: ActionPlanViewComponent;
    @ViewChild(ToolsViewComponent) userDetailsToolsComp!: ToolsViewComponent;
    @ViewChild(UserOrgOwnContentComponent) userDetailsOrgContentComp!: UserOrgOwnContentComponent;

    constructor(
        private api: ApiService,
        private log: LogService,
        private activatedRoute: ActivatedRoute,
        private professionalService: ProfessionalService,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        let currentDate = new Date();
        let rangeDate = new Date(
            new Date().setDate(currentDate.getDate() - 30)
        );
        this.paramsSub = this.activatedRoute.params.subscribe(params => {
            this.id = parseInt(params['id'], 10);
            setTimeout(() => {
                this.professionalService
                    .getCounts(this.id, '1-3-13-21', rangeDate, currentDate)
                    .subscribe(result => {
                        this.countData = result;
                    });
                this.getUserActionPlans();
                this.getDemographic();
                this.initData();
            }, 100);
        });

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.getUserActionPlans();
        });
        this.loadDataForTab(0);
    }

    onTabChanged(event: MatTabChangeEvent) {
        let tabSelected = event.tab.textLabel;
        this.selectedTabIndex = event.index;
        this.loadDataForTab(this.selectedTabIndex);
    }

    loadDataForTab(index: number) {
        switch (index) {
            case 0:
                this.userDetailOverview = true;
                setTimeout(() => {
                    this.userDetailsOverviewComp?.getAssignment?.();
                });
                break;
            case 1:
                this.assessmentView = true;
                setTimeout(() => {
                    this.userDetailsAssessmentComp?.getAssignedList?.();
                });
                break;
            case 2:
                this.moodcheckView = true;
                setTimeout(() => {
                    this.userDetailsMoodcheckComp?.getAssignedList?.();
                });
                break;
            case 3:
                this.seriesView = true;
                setTimeout(() => {
                    this.userDetailsSeriesComp?.getAssignment?.();
                });
                break;
            case 4:
                this.orgContentView = true;
                setTimeout(() => {
                    this.userDetailsOrgContentComp?.getAssignment?.();
                });
                break;
            case 5:
                this.actionplanView = true;
                setTimeout(() => {
                    this.userDetailsActionPlanComp?.getAssignedList?.();
                });
                break;
            case 6:
                this.toolsView = true;
                setTimeout(() => {
                    this.userDetailsToolsComp?.getAssignedList?.();
                });
                break;
        }
    }

    initData() {
        this.api.get('users/' + this.id, {}).subscribe(
            (result: any) => {
                this.user = new User(result.data);
                this.log.event(AnalyticEvent.event.userDetailsLoaded);
                this.isLoaded = true;
            },
            (error: any) => {
                this.log.error('Error fetching user. ' + error.message);
            }
        );
    }

    getDemographic() {
        this.api.get('demographic/' + this.id).subscribe(
            (result: any) => {
                this.demographicDetail = result.data[0];
                this.isLoaded = true;
            },
            (error: any) => {
                this.isLoaded = false;
                this.log.error(
                    'Error getting assessment questions. ' + error.message
                );
            }
        );
    }

    getUserActionPlans() {
        this.api.get(`syncheduser/actionplans/${this.id}`).subscribe(
            (result: any) => {
                if (result.data) {
                    this.userActionPlans = ActionPlanDashboard.initializeArray(
                        result.data,
                        this.id
                    );
                }
            },
            error => {
                this.userActionPlans = [];
                this.log.error('Error getting action plan. ' + error.message);
            }
        );
    }
}
